// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7566":"cfea4c74","9894":"839f0742"}[chunkId] + ".chunk.css";
};